import { HTMLAttributes } from "react";

interface DownloadableDocumentProps extends HTMLAttributes<HTMLAnchorElement> {
  label: string;
  url: string;
  validUrl?: boolean;
}

export const DownloadableDocument = ({
  label,
  url,
  validUrl = true,
  ...anchorAttributes
}: DownloadableDocumentProps) => {
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      {...anchorAttributes}
      href={url}
    >
      <div className="flex justify-between text-secondary-80 stroke-secondary-80">
        <div className="text-body-small font-semibold">{label}</div>

        {validUrl ? (
          <span className="text-[20px] mgc_document_2_line" />
        ) : (
          <span className="stroke-secondary-80">-</span>
        )}
      </div>
    </a>
  );
};
